/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/mehfil/"

const MEHFIL: CommunityData = {
  code: "mehfil",
  inviteCode: "mehfil",
  name: "Mehfil",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/meh-442`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmgqjn67u00099k2q5j1ngzgx.jpg?uploadTime=1773823568353&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[174px] h-[174px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#4266b4",
      asideBg: "#049360",
      asideStyles: "border-r border-[#000000]",
      contentBg: "#4266b4",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['MinionProMedium']",
      primaryButton:
        "bg-[#f55f50] border border-[#000000] px-[18px] py-[18px] !text-[#222222] font-['InterRegular'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#000000]",
      item: "font-['MinionProMedium'] text-[16px] text-[#000000] text-left leading-[120%] gap-x-[10px] text-opacity-50 text-center border-b border-[#000000] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#4266b4] border border-[#000000] rounded-[24px] !pb-8",
      titles: "text-[#000000] font-['SuperPastryRegular'] text-[30px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['SuperPastryRegular'] text-[30px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#000000] font-['SuperPastryRegular'] text-[17px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['MinionProMedium'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['SuperPastryRegular'] text-[30px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#000000] font-['SuperPastryRegular'] text-[17px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['MinionProMedium'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#000000] font-['MinionProMedium'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['SuperPastryRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['MinionProMedium'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['SuperPastryRegular'] text-[30px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    comingSoon: {
      bgColor: "#4266b4",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
        style: "bg-[#4266b4]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[100px] h-[100px] sm:w-[174px] sm:h-[174px]",
      },
      werzLogoColor: "#000",
      title: "font-['SuperPastryRegular'] text-[28px] leading-[100%] text-[#000000]",
      text: "font-['MinionProMedium'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['InterRegular'] text-[16px] leading-[120%] p-4 bg-[#f55f50] border border-[#000000] text-[#222222] cursor-pointer w-fit",
      input: {
        base: "font-['MinionProMedium'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#000000]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['MinionProMedium'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['MinionProMedium'] text-[14px] leading-[120%] text-[#000000]",
      skipButton:
        "font-['MinionProMedium'] text-[14px] leading-[120%] text-[#000000] cursor-pointer",
      modal: {
        container: "bg-white px-[40px] py-[48px]",
        title: "font-['SuperPastryRegular'] text-[24px] leading-[100%] text-[#000000] text-center",
        text: "font-['MinionProMedium'] text-[14px] leading-[120%] text-[#000000] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-[#f0f0f0] font-['MinionProMedium'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    linktree: {
      bgDesktop:
        "https://media.werz.at/community-assets/mehfil/web-background-non-member.mp4?type=video",
      bgMobile:
        "https://media.werz.at/community-assets/mehfil/web-background-non-member.mp4?type=video",
      bgColor: "#4266b4",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#4266b4]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#f7d58e] font-['SuperPastryRegular'] text-[30px] leading-[30px] text-center text-center mt-4 mb-1",
        location:
          "font-['SuperPastryRegular'] leading-[22px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['MinionProMedium'] text-[16px] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#4266b4] border border-[#000000] rounded-[24px] text-[#000000] font-['MinionProMedium'] text-[16px] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#4266b4] border border-[#000000] rounded-[24px]",
          title:
            "font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['MinionProMedium'] text-[16px] text-center text-center",
          button:
            "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#f7d58e] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#4266b4] border border-[#000000] rounded-[24px]",
          duration: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          name: "text-[#000000] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#4266b4] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#049360] border border-[#000000] text-[#000000] font-['SuperPastryRegular'] text-[17px] leading-[17px] text-center",
          duration: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          location: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          button:
            "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['SuperPastryRegular'] leading-[17px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['SuperPastryRegular'] leading-[17px] text-[14px] text-left",
            link: "text-[#000000] font-['MinionProMedium'] text-[16px] text-left",
            status:
              "text-[#000000] font-['SuperPastryRegular'] leading-[100%] text-[14px] text-left",
            button:
              "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['MinionProMedium'] text-[16px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#4266b4] border border-[#000000] rounded-[24px] text-[#000000] font-['MinionProMedium'] text-[16px] text-center",
        header:
          "text-[#f7d58e] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#4266b4] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
        },
        seeAllNews:
          "text-[#000000] font-['MinionProMedium'] text-[16px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#4266b4] border border-[#000000] rounded-[24px] text-[#000000] font-['MinionProMedium'] text-[16px] text-center",
        header:
          "text-[#f7d58e] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#4266b4] border border-[#000000] rounded-[24px]",
          coverUrl: "overflow-hidden m-2 border border-[#000000] rounded-[24px]",
          duration: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          liveType: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#000000",
          start: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
          title:
            "text-[#000000] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['MinionProMedium'] text-[16px] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#4266b4] border border-[#000000] rounded-[24px] text-[#000000] font-['MinionProMedium'] text-[16px] text-center",
        header:
          "text-[#f7d58e] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#4266b4] border border-[#000000] rounded-[24px]",
          name: "text-[#000000] font-['SuperPastryRegular'] leading-[22px] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000] rounded-[24px]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#000000] font-['MinionProMedium'] text-[12px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#4266b4] border border-[#000000] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#000000]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#000000] font-['SuperPastryRegular'] text-[30px] text-left leading-[100%]",
        subtitle:
          "text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#f55f50] border border-[#000000] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['InterRegular'] !text-[16px] text-left",
        questions: "text-[16px] text-left leading-[130%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['SuperPastryRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['SuperPastryRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#000000] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['SuperPastryRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['SuperPastryRegular'] text-[24px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#4266b4] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#000000] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['SuperPastryRegular'] text-[17px] text-left leading-[100%] mb-1",
          description:
            "text-[#000000] font-['MinionProMedium'] text-[16px] text-left leading-[130%] mb-1 flex flex-row",
          price: "text-[#000000] font-['SuperPastryRegular'] text-[17px] text-left leading-[100%]",
          quantity: "text-[#000000] font-['InterRegular'] text-[14px] text-left",
          status: "text-[#000000] font-['SuperPastryRegular'] text-[17px] text-left leading-[100%]",
          counterContainer:
            "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#f55f50] border border-[#000000] px-[16px] py-[12px] text-[#000000] font-['InterRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default MEHFIL
